var React = require('react');

function SmTwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0416787 0L6.64177 8.82495L0 16H1.4948L7.30965 9.71813L12.0079 16H17.0947L10.1233 6.67867L16.3054 0H14.8106L9.45542 5.78548L5.12853 0H0.0416787ZM2.23989 1.10107H4.5768L14.8962 14.8988H12.5593L2.23989 1.10107Z"}));
}

SmTwitterInline.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = SmTwitterInline;

SmTwitterInline.default = SmTwitterInline;
